
import { defineComponent } from 'vue'
import store from '@/store'

export default defineComponent({
    props: ['rule'],
    data: function () {
        return {
            $store: store
        }
    },
    methods: {
        ok: function () {
            this.$emit('close')
        }
    }
})
